import { Component, input, output } from '@angular/core';
import { Asset } from 'app/classes/asset';
import { APIService } from 'app/shared/api.service';
import { AssetService } from 'app/shared/asset.service';
import { D3ChartService, IAnnotationItem } from 'app/shared/d3chart.service';

@Component({
  selector: 'app-d3-chart-annotate',
  standalone: false,
  templateUrl: './d3-chart-annotate.component.html',
  styleUrl: './d3-chart-annotate.component.css'
})
export class D3ChartAnnotateComponent {

  asset = input.required<Asset>();
  item = input.required<IAnnotationItem>();
  annotation: any = { text: '', users: [] };
  onClose = output<boolean>();

  constructor(private apiService: APIService, private d3Service: D3ChartService, private assetService: AssetService) {
  }

  annotationDelete() {
    this.annotation.text = '';
    this.annotationSave();
  }

  annotationSave() {
    if (this.annotation.text.trim().length < 1) {
      this.apiService.toastWarn('Please enter some notes', '');

      return;
    }

    const body = {
      annotation: {
        avid: this.item().telemetry.i,
        uid: this.apiService.getUserId(),
        orgId: this.apiService.getUserOrg().id,
        text: this.annotation.text,
        users: this.annotation.users
      }
    }
    this.log('Saving annotation', body);

    let a = { text: this.annotation.text, asset_value_id: this.item().telemetry.i, value: this.item().telemetry.v };

    this.apiService.postAsset(this.asset().id, body)
      .then(r => {
        this.log(r);
        this.onClose.emit(true);
      })
      .catch(e => {
        this.log(e);
        this.onClose.emit(true);
      });
  }

  log(...txt: any) {
    console.log(...txt);
  }

}
